import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { GuaranteeLetter } from './types';

export const guaranteeLettersApi = createApi({
  reducerPath: 'guaranteeLettersApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/guarantee-letters',
  }),
  tagTypes: ['GuaranteeLetter', 'GuaranteeLetters'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getGuaranteeLetterById: builder.query<GuaranteeLetter, { id: string }>({
      query: ({ id }) => ({
        url: `/${id}`,
      }),
      providesTags: () => ['GuaranteeLetters'],
    }),
    createGuaranteeLetter: builder.mutation<GuaranteeLetter, FormData>({
      query: data => ({
        url: '/',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['GuaranteeLetters'],
    }),
    updateGuaranteeLetter: builder.mutation<GuaranteeLetter, FormData>({
      query: data => ({
        url: `/${data.get('id')}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: result => [
        'GuaranteeLetters',
        { type: 'GuaranteeLetter', id: result?.id },
      ],
    }),
  }),
});

export const {
  useGetGuaranteeLetterByIdQuery,
  useCreateGuaranteeLetterMutation,
  useUpdateGuaranteeLetterMutation,
} = guaranteeLettersApi;
